export const creationGroups = [
    { key: 'markets', label: 'Markets', options: [{ key: 'spot', label: 'Spot' }, { key: 'linear', label: 'Futures' }] },
    { key: 'bot_types', label: 'Bot types', options: [{ key: 'dca', label: 'DCA' }, { key: 'strategy', label: 'Strategy' }] },
    { key: 'dca_modes', label: 'DCA modes', options: [
        { key: 'signal', label: 'Trading DCA' },
        { key: 'alert_averaging', label: 'Alert Averaging DCA' },
        { key: 'hybrid', label: 'Hybrid DCA' },
        { key: 'accumulation', label: 'Portfolio Accumulation (Spot)' }
    ] }
]

export function defaultCreationVisibility() {
    return {
        visible_to_all: true, visible_to_admin_only: false,
        ...Object.fromEntries(creationGroups.map(group => [group.key,
            Object.fromEntries(group.options.map(option => [option.key, option.key !== 'hybrid']))]))
    }
}

export function resolveCreationVisibility(settings = {}) {
    const defaults = defaultCreationVisibility()
    const stored = settings['create-bot']
    const result = stored ? { ...defaults, ...stored } : defaults
    for (const group of creationGroups) result[group.key] = { ...(stored ? stored[group.key] : defaults[group.key]) }
    if (settings['strategy-bot-type']?.visible_to_all === false) result.bot_types.strategy = false
    return result
}

export function creationCapabilities(settings, owner = false) {
    const visibility = owner ? defaultCreationVisibility() : resolveCreationVisibility(settings)
    const enabled = owner || visibility.visible_to_all === true
    const markets = enabled ? ['spot', 'linear'].filter(market => visibility.markets[market] === true) : []
    const modes = market => markets.includes(market) && visibility.bot_types.dca === true
        ? ['signal', 'alert_averaging', 'hybrid', 'accumulation'].filter(mode => (owner || visibility.dca_modes[mode] === true) && (mode !== 'accumulation' || market === 'spot')) : []
    const strategy = markets.length > 0 && visibility.bot_types.strategy === true
    const categories = [...markets.filter(market => modes(market).length > 0), ...(strategy ? ['strategy'] : [])]
    return { markets, modes, strategy, categories, available: categories.length > 0 }
}
